import { TabList } from 'react-tabs'
import Flex from 'typescript-styled-flex'
import styled from '../../../theme'

const BBTabList = styled(Flex.withComponent(TabList) as any)<any>`
  margin: 0px;
  padding: 0px;
  padding-top: 20px;
  -webkit-box-shadow: 0 8px 6px -6px rgba(215, 215, 215, 0.75);
  -moz-box-shadow: 0 8px 6px -6px rgba(215, 215, 215, 0.75);
  box-shadow: 0 8px 6px -6px rgba(215, 215, 215, 0.75);
`

export default BBTabList
